import { HashRouter as Router, Routes, Route } from "react-router-dom";
import { FluentProvider, webLightTheme } from '@fluentui/react-components';
import { useEffect, useState } from "react";
import Menu from "./Menu";
import "./App.css";
import AiNotEnabledScene from "../scenes/AiNotEnabledScene";
import EmployeeDetailScene from "../scenes/EmployeeDetailScene";
import ConsentScreen from "../scenes/ConsentScreenScene";
import ObservationForm from "../scenes/ObservationFormScene";
import SuccessScreen from "../scenes/SuccessScreenScene";
import NoAccessScene from "../scenes/NoAccessScene";
import DebugScene from "../scenes/DebugScene";
import Privacy from "./Privacy";
import TermsOfUse from "./TermsOfUse";
import TranscriptConsentConfig from "./TranscriptConsentConfig";
import FormSelectionScene from "../scenes/FormSelectionScene";
import IncorrectDetailsScene from "../scenes/IncorrectDetailsScene";
import UnexpectedErrorScene from "../scenes/UnexpectedErrorScene";
import { checkAiEligibility } from "../services/auth";
import * as microsoftTeams from "@microsoft/teams-js";

/**
 * The main app which handles the initialization and routing
 * of the app.
 */
export default function App() {
  const [isAiEnabled, setIsAiEnabled] = useState(true);
  const [loading, setLoading] = useState(true);
  const [unexpectedError, setUnexpectedError] = useState(false);

  useEffect(() => {
    const fetchAiEligibility = async () => {
      try {
        microsoftTeams.initialize();
        microsoftTeams.getContext(async (context) => {
          try {
            const meetingId = (context as any)?.chatId || "";
            const aiEnabled = await checkAiEligibility(meetingId);
            setIsAiEnabled(aiEnabled);
          } catch (error) {
            console.error("Error checking AI eligibility:", error);
            setUnexpectedError(true);
          } finally {
            setLoading(false);
          }
        });
      } catch (error) {
        console.error("Error checking AI eligibility:", error);
        setUnexpectedError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchAiEligibility();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (unexpectedError) {
    return (
      <FluentProvider theme={webLightTheme}>
        <Router>
          <UnexpectedErrorScene />
        </Router>
      </FluentProvider>
    );
  }

  if (!isAiEnabled) {
    return (
      <FluentProvider theme={webLightTheme}>
        <Router>
          <AiNotEnabledScene />
        </Router>
      </FluentProvider>
    );
  }

  return (
    <FluentProvider theme={webLightTheme}>
      <Router>
        <Routes>
          {/* /config route required for app to load in teams. */}
          <Route path="/config" element={<TranscriptConsentConfig />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/termsofuse" element={<TermsOfUse />} />
          <Route path="/aiNotEnabled" element={<AiNotEnabledScene />} />
          <Route path="/menu" element={<Menu />} />
          <Route path="/employeeDetails" element={<EmployeeDetailScene />} />
          <Route path="/observationForm" element={<ObservationForm />} />
          <Route path="/success-screen" element={<SuccessScreen />} />
          <Route path="/noAccess" element={<NoAccessScene />} />
          <Route path="/consentScreen" element={<ConsentScreen />} />
          <Route path="/incorrect-details" element={<IncorrectDetailsScene />} />
          <Route path="/debug" element={<DebugScene />} />
          <Route path="/formSelection" element={<FormSelectionScene />} />
          {/* Default routes to EmployeeDetailScene */}
          <Route path="/" element={<EmployeeDetailScene />} />
          <Route path="/tab" element={<EmployeeDetailScene />} />
        </Routes>
      </Router>
    </FluentProvider>
  );
}
